import { render, staticRenderFns } from "./InfoCuponAmigoPendiente.vue?vue&type=template&id=4ed3b34d&"
import script from "./InfoCuponAmigoPendiente.vue?vue&type=script&lang=js&"
export * from "./InfoCuponAmigoPendiente.vue?vue&type=script&lang=js&"
import style0 from "./InfoCuponAmigoPendiente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports